import noRecurringOrders from 'src/assets/svg/order/illo-calendar.svg';
import { MealPlanFormat, MealPlanStatus } from 'src/gqlReactTypings.generated.d';
import { Loading } from 'src/shared/design-system/Loading';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { ConsumerMealPlanCard } from './ConsumerMealPlanCard';
import { EmptyOrdersContainer, OrdersListTitle } from './styles';

export type MealPlanType = {
  id: string;
  displayName: string;
  unit: number;
  weeklyCost: number;
  pricePerUnit: number;
  numServings: number;
};

export type MealPlanData = {
  id: string;
  status: MealPlanStatus;
  mealPlanType: {
    unit: number;
    weeklyCost: number;
    numServings: number;
    format?: MealPlanFormat | null;
  };
};

export const MealPlansTab: React.FC<{ mealPlan?: MealPlanData | null }> = ({ mealPlan }) => {
  const [, currentUserIsLoading] = useCurrentUser();

  if (currentUserIsLoading) {
    return <Loading />;
  }

  if (!mealPlan) {
    return (
      <EmptyOrdersContainer>
        <img src={noRecurringOrders} alt='no meal plans' />
        <OrdersListTitle>You have no meal plans.</OrdersListTitle>
      </EmptyOrdersContainer>
    );
  }

  return <ConsumerMealPlanCard mealPlan={mealPlan} />;
};
